/**
 * React
 */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Hooks
 */
import useInterval from 'hooks/useInterval';
import useLibrary from 'hooks/useLibrary';

/**
 * Constants
 */
import { SearchCondition } from 'commons/constants/KeyFlowConstants';

/**
 * VO
 */
import LibraryParamVO from 'commons/vo/param/LibraryParamVO';
import { compareJobStatusAfterRequestLibraryList } from 'redux/actions/actions';

function useLibraryNotification() {
  const dispatch = useDispatch();

  useInterval(
    () => {
      const param = new LibraryParamVO({
        retr: 100,
        sort: SearchCondition.Sort.DATE_OF_CREATED,
        page: 0,
        asc: SearchCondition.Asc.DESC,
      });
      dispatch(compareJobStatusAfterRequestLibraryList({ param }));
    },
    { delay: 5, isInvoke: true, isFirstInvoke: true },
    [],
  );
}

export default useLibraryNotification;
